export interface News {
    masterId: string,
    createdByUser: string,
    modifiedByUser: string,
    createdDate: Date,
    modifiedDate:Date,
    isDraft: boolean,
    isActive: boolean,
    isDeleted: boolean,
    version: number,
    names: {
        [key: string]: string;
    },
    descriptions: {
        [key: string]: string;
    },
    imageUrl: string,
    link: string
}

export interface PagedNews {
    items: News[],
    totalCount: number,
}
export const NEWS_FIELD_LABELS: Record<string, string> = {
    names: "Naziv",
    descriptions: "Opis",
    isActive: "Aktivan",
    isDraft: "Skica",
    isDeleted: "Obrisano",
    link: "URL",
    image: "Slika",
}

